import { ConditionRegistryItem } from '../../../../registry/condition/ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../../../registry/condition/ConditionRegistryCategory';
export class ConditionsSelectTask extends ConditionRegistryCategory {
    label = 'Select Task';
    constructor(parent) {
        super(parent);
        super.init();
    }
    selectTask_correctlySelected = () => new ConditionRegistryItem({
        label: 'SelectTask korrekt ausgewählt',
        eval: ({ selectTask }) => !!selectTask && selectTask.taskEval.isCorrectlySelected,
    });
    selectTask_wronglySelected = () => new ConditionRegistryItem({
        label: 'SelectTask falsch ausgewählt',
        eval: ({ selectTask }) => !!selectTask && selectTask.taskEval.isWronglySelected,
    });
    selectTask_wrong = () => new ConditionRegistryItem({
        label: 'SelectTask falsch abgeschlossen',
        eval: ({ selectTask }) => !!selectTask && selectTask.taskEval.isWronglySelected && selectTask.taskProgress.isTaskComplete,
    });
    selectTask_isCompleted = () => new ConditionRegistryItem({
        label: 'SelectTask ist komplett',
        eval: ({ selectTask }) => !!selectTask && selectTask.taskProgress.isTaskComplete,
    });
}
